// A repeated ?teamId= arrives as an array with no way to tell which copy the link meant, so it is
// discarded rather than guessed at.
export const getInboxTeamIdFromQuery = (query: Record<string, string | string[] | undefined>): string | null => {
  const queryTeamId = query.teamId;
  return typeof queryTeamId === "string" && queryTeamId !== "" ? queryTeamId : null;
};

export const resolveInboxTeamId = (queryTeamId: string | null, storedTeamId: string, isUnknownTeam: boolean): string =>
  queryTeamId !== null && !isUnknownTeam ? queryTeamId : storedTeamId;
